import React from 'react';
import styles from './AuthorHeader.module.css';

interface AuthorHeaderProps {
    username: string;
    avatar: string;
    rating: number;
    bio: string;
    email: string;
    registrationDate: string;
    lastActivity: string;
}

const AuthorHeader: React.FC<AuthorHeaderProps> = ({
                                                       username,
                                                       avatar,
                                                       rating,
                                                       bio,
                                                       email,
                                                       registrationDate,
                                                       lastActivity
                                                   }) => {
    // Фразы для рейтинга
    const ratingPhrases = [
        "Просто бог кода 👑",
        "Почти как Чак Норрис в программировании 💪",
        "Пишет код лучше, чем кофе варит ☕",
        "Его код не багуется, это фичи 🐛➡️✨",
        "Рейтинг зашкаливает! 📈"
    ];

    const randomPhrase = ratingPhrases[Math.floor(Math.random() * ratingPhrases.length)];

    return (
        <div className={styles.authorHeader}>
            <div className={styles.avatarSection}>
                <img src={avatar} alt={username} className={styles.avatar}/>
                <div className={styles.ratingBadge}>
                    <span className={styles.ratingValue}>{rating}/5</span>
                    <span className={styles.ratingText}>Рейтинг</span>
                    <div className={styles.ratingTooltip}>{randomPhrase}</div>
                </div>
            </div>

            <div className={styles.authorInfo}>
                <h1 className={styles.authorName}>{username}</h1>
                <p className={styles.authorBio}>{bio}</p>

                <div className={styles.metaInfo}>
                    <div className={styles.metaItem}>
                        <span className={styles.metaIcon}>📧</span>
                        <span><a href={`mailto:${email}`} target="_blank">{email}</a></span>
                    </div>
                    <div className={styles.metaItem}>
                        <span className={styles.metaIcon}>📅</span>
                        <span>На сайте с {registrationDate}</span>
                    </div>
                    <div className={styles.metaItem}>
                        <span className={styles.metaIcon}>🕒</span>
                        <span>Был(а) {lastActivity}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthorHeader;